import request from '../../config/axiosConfig';
import { UPLOAD_IMAGE } from '../../constants/apiEndPoint';

export const uploadImageRequest = async (file) => {
  const formData = new FormData();
  formData.append('file', file);
  const result = await request({
    url: UPLOAD_IMAGE,
    method: 'POST',
    data: formData,
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return result?.data?.data;
};
